import { useState } from "react";
import PageHero from "@/components/PageHero";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
import Seo from "@/components/Seo";
import { pageImages } from "@/data";

const offices = [
  { city: "Gurgaon", country: "India" },
  { city: "Colombo", country: "Sri Lanka" },
  { city: "Dubai", country: "United Arab Emirates" },
];

const trust = [
  { img: pageImages.partnerWhy1, title: "Destination Expertise", desc: "We operate across 30+ destinations with on-ground teams, local partnerships, and decades of operational insights." },
  { img: pageImages.partnerWhy2, title: "Certified & Committed", desc: "We\u2019re ISO 45001, Travelife, and IATA certified, meeting global benchmarks for safety, sustainability, and service quality across all our brands." },
  { img: pageImages.partnerWhy1, title: "Proven Track Record", desc: "From handling 100,000+ travelers to delivering consistent results for B2B and B2C segments, our reliability is built on experience, not promises." },
];

const valueTabs = [
  { icon: "\uD83C\uDF0D", title: "Destination Mastery", desc: "From ground handling to immersive local experiences, we provide the infrastructure, insight, and execution support to make complex itineraries effortless, no matter the region." },
  { icon: "\uD83E\uDDF3", title: "Network & Connections", desc: "We work with a trusted ecosystem of hotels, airlines, local operators, and experience providers, giving us direct access to negotiated rates, exclusive availability, and on-ground reliability." },
  { icon: "\uD83E\uDD1D", title: "Traveler-Centric Design", desc: "We build journeys around people, not templates, balancing personalization with operational efficiency to serve both individuals and large groups at scale." },
];

const PartnerPage = () => {
  const [tab, setTab] = useState(0);
  const [sent, setSent] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <main className="page">
      <Seo
        title="Partner With Us"
        path="/partner"
        description="Partner with HI Tours Group. Whether you're a tour operator, travel advisor, corporate planner, or service provider, we help you deliver world-class travel at scale."
      />
      <PageHero eyebrow="Partner with us" title="Let’s Create Travel That Moves People" subtitle="Whether you're a tour operator, travel advisor, corporate planner, or service provider, our team is here to help you deliver world-class experiences at scale." />

      <section className="section">
        <div className="container contact">
          <div className="contact__intro">
            <span className="badge"><span className="badge__dot" />Get in touch</span>
            <h2 className="contact__title">Let’s Talk Travel!</h2>
            <p className="section__lead">We’re here to help, whether you’re planning your next journey, exploring partnerships, or just want to say hello. Expect fast replies, clear communication, and a team that’s always within reach.</p>
            <ul className="contact__offices">
              {offices.map((o) => (
                <li key={o.city}><strong>{o.city}</strong><span>{o.country}</span></li>
              ))}
            </ul>
          </div>

          <form className="contact__form" onSubmit={onSubmit}>
            {sent ? (
              <div className="contact__success">
                <div className="contact__success-icon">✓</div>
                <h3>Thank you!</h3>
                <p>Your message has been received. Our team will be in touch shortly.</p>
              </div>
            ) : (
              <>
                <label>Full Name *<input type="text" required placeholder="Your name" /></label>
                <label>Phone *<input type="tel" required placeholder="+91" /></label>
                <label>Email *<input type="email" required placeholder="you@company.com" /></label>
                <label>Your Message<textarea rows="4" placeholder="Tell us about your requirement" /></label>
                <button type="submit" className="btn btn--solid"><span className="btn__dot" />Submit</button>
              </>
            )}
          </form>
        </div>
      </section>

      <section className="section why">
        <div className="container">
          <div className="why__head">
            <span className="badge"><span className="badge__dot" />Why they trust us</span>
            <h2 className="why__title">Why top travel partners, corporates, and creators choose Hi Tours Group</h2>
          </div>
          <div className="feature-grid feature-grid--3">
            {trust.map((c) => (
              <article className="feature-card" key={c.title}>
                <img className="feature-card__img" src={c.img} alt={c.title} loading="lazy" />
                <h3 className="feature-card__title">{c.title}</h3>
                <p className="feature-card__desc">{c.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section value">
        <div className="container">
          <div className="why__head">
            <span className="badge"><span className="badge__dot" />How we deliver value</span>
            <h2 className="why__title">Innovating the way you grow.</h2>
          </div>
          <div className="value__tabs">
            {valueTabs.map((v, i) => (
              <button key={v.title} className={`value__tab ${i === tab ? "value__tab--active" : ""}`} onClick={() => setTab(i)}>
                <span className="value__icon">{v.icon}</span>
                <span className="value__tab-title">{v.title}</span>
                <span className="value__tab-desc">{v.desc}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Testimonials />
      <CTA />
    </main>
  );
};

export default PartnerPage;
